import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { updateSelectedTake } from "../../app/slices/TrainingSlice";
import PiInputfield from "../../components/PiInputField";
import Take3D from "../../models/Take3D";

export default function TakeStartDelayField({ take }: { take: Take3D }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [invalid, setInvalid] = useState(false);
  const active = useRef(true);
  const delay = take.interactionStartDelay ?? 1;

  useEffect(() => {
    active.current = true;
    return () => {
      active.current = false;
    };
  }, []);

  useEffect(() => {
    setInvalid(false);
  }, [delay]);

  return (
    <PiInputfield
      label={t("interaction_start_delay")}
      placeholder="1"
      value={String(delay)}
      type="number"
      min={0}
      step={0.1}
      square
      showInfoButton
      info={t("tooltip_interaction_start_delay") ?? undefined}
      error={invalid}
      errorMessage={t("interaction_start_delay_error") ?? undefined}
      onChange={(text) => {
        // A pending debounce from an unmounted Take must not edit its successor.
        if (!active.current) return;
        const value = Number(text);
        const isInvalid = text.trim() === "" || !Number.isFinite(value) || value < 0;
        setInvalid(isInvalid);
        if (!isInvalid && value !== delay) {
          const updatedTake: Take3D = { ...take, interactionStartDelay: value };
          dispatch(updateSelectedTake(updatedTake));
        }
      }}
    />
  );
}
